module.exports = __webpack_public_path__ + "img/full2-min.455adfc5.png";